import { render, staticRenderFns } from "./group-item.vue?vue&type=template&id=f3a93efa&scoped=true"
import script from "./group-item.vue?vue&type=script&lang=js"
export * from "./group-item.vue?vue&type=script&lang=js"
import style0 from "./group-item.vue?vue&type=style&index=0&id=f3a93efa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a93efa",
  null
  
)

export default component.exports